import styled from 'styled-components'
import { vars } from '@snsw-gel/theming'

export const UploadedItemContainer = styled.div`
    background-color: ${vars.colors.background.subtle};
    padding: ${vars.spacing.sm};
    font-weight: ${vars.font.weight.mediumLow};
    display: flex;
    align-items: center;
    justify-content: space-between;

    .uploaded-item__file-info {
        margin-right: ${vars.spacing.sm};
        word-break: break-all;
    }

    .uploaded-item__file-size {
        white-space: nowrap;
    }

    .uploaded-item__button-element {
        flex-shrink: 0;
    }
`
